// B2B Router - Main entry point for B2B dashboard
import { Routes, Route } from 'react-router-dom';
import { B2BProvider } from './context/B2BContext';
import B2BLayout from './components/B2BLayout';
import B2BLogin from './pages/B2BLogin';
import B2BSignup from './pages/B2BSignup';
import B2BDashboard from './pages/B2BDashboard';
import B2BLeads from './pages/B2BLeads';
import B2BLeadDetail from './pages/B2BLeadDetail';
import B2BSettings from './pages/B2BSettings';
import B2BWidgetContent from './pages/B2BWidgetContent';
import './B2B.css';
import B2BBilling from './pages/B2BBilling';

export default function B2BRouter() {
  return (
    <B2BProvider>
      <Routes>
        {/* Public routes */}
        <Route path="login" element={<B2BLogin />} />
        <Route path="signup" element={<B2BSignup />} />
        
        {/* Protected routes */}
        <Route element={<B2BLayout />}>
          <Route index element={<B2BDashboard />} />
          <Route path="leads" element={<B2BLeads />} />
          <Route path="leads/:leadId" element={<B2BLeadDetail />} />
          <Route path="widget-content" element={<B2BWidgetContent />} />
          <Route path="settings" element={<B2BSettings />} />
          <Route path="settings/*" element={<B2BSettings />} />
          <Route path="/billing" element={<B2BBilling />} />
        </Route>
      </Routes>
    </B2BProvider>
  );
}
